import { Badge } from '@pixlide/ui';
import { useAssignConversation } from '@/api/queries/messages';
import type { components } from '@/api/generated/schema';

type PlatformAdminListItem = components['schemas']['PixlideApplicationFeaturesPlatformAdminPlatformAdminListItem'];

const UNASSIGNED_VALUE = '';

/**
 * Badge + `<select>` d'assignation d'une conversation à un administrateur plateforme.
 * Pas de modale dans ce design system : le `<select>` applique directement le changement à la
 * sélection, comme les contrôles inline de `TenantDetailPage.tsx`.
 */
export function AssignmentControl({
  tenantId,
  assignedAdminUserId,
  assignedAdminName,
  admins,
}: {
  tenantId: string;
  assignedAdminUserId: string | null;
  assignedAdminName: string | null;
  admins: PlatformAdminListItem[];
}) {
  const assignConversation = useAssignConversation(tenantId);

  function handleChange(value: string) {
    if (assignConversation.isPending) return;
    assignConversation.mutate(value === UNASSIGNED_VALUE ? null : value);
  }

  return (
    <div className="flex items-center gap-2">
      <Badge tone={assignedAdminUserId ? 'brand' : 'neutral'}>
        {assignedAdminUserId ? `Assigné à ${assignedAdminName ?? '—'}` : 'Non assigné'}
      </Badge>

      <select
        aria-label={`Assigner la conversation de ${tenantId}`}
        value={assignedAdminUserId ?? UNASSIGNED_VALUE}
        onChange={(event) => handleChange(event.target.value)}
        onClick={(event) => event.stopPropagation()}
        disabled={assignConversation.isPending}
        className="h-8 rounded-pill bg-white px-2 text-xs ring-1 ring-ink-100 focus:ring-brand-500 disabled:opacity-50"
      >
        <option value={UNASSIGNED_VALUE}>Non assigné</option>
        {admins.map((admin) => (
          <option key={admin.id} value={admin.id}>
            {admin.firstName} {admin.lastName}
          </option>
        ))}
      </select>
    </div>
  );
}
